import Headings from 'admin/components/atoms/Headings';
import Link from 'admin/components/atoms/Link';
import Loader from 'admin/components/atoms/Loader';
import Table from 'admin/components/atoms/Table';
import Pager from 'admin/components/shared/Pager';
import { formatDate } from 'admin/utils';
import React from 'react';
import styled from 'styled-components';
import { createBadge } from '../../atoms/Badge';

const SearchResult = styled.span`
  display: inline-block;
  margin-left: 1rem;
`;

const LoaderWrapper = styled.div`
  background: #f5f5f5;
  text-align: center;
  padding: 1rem;
`;

const Badge = createBadge({
  ENABLED: {
    label: '有効',
  },
  DISABLED: {
    label: '無効',
    bgColor: 'grey',
  },
});

const CouponListRow = ({ data: coupon }) => {
  return (
    <Table.Row key={coupon.id} styles={{ background: coupon.is_disabled ? '#ddd' : 'unset' }}>
      <Table.Cell>
        <Badge status={coupon.is_disabled ? 'DISABLED' : 'ENABLED'} />
      </Table.Cell>
      <Table.Cell>{formatDate(coupon.starts_at, 'YYYY/MM/DD HH:mm')}</Table.Cell>
      <Table.Cell>{formatDate(coupon.ends_at, 'YYYY/MM/DD HH:mm')}</Table.Cell>
      <Table.Cell wordBreak="break-word">
        <Link to={`/promotion/coupons/${coupon.id}`}>{coupon.name}</Link>
      </Table.Cell>
      <Table.Cell wordBreak="break-word">{coupon.issued_shop.name}</Table.Cell>
    </Table.Row>
  );
};

const CouponListTable = ({ coupons = [], isLoading, pagination, onChangePage }) => {
  return (
    <div>
      <Headings.h5>検索結果</Headings.h5>
      {isLoading ? (
        <LoaderWrapper>
          <Loader type="Oval" height={50} width={50} />
        </LoaderWrapper>
      ) : (
        <>
          <SearchResult>件数: {coupons.count}</SearchResult>
          <Table>
            <Table.Header>
              <Table.Row>
                <Table.Cell size="1">状態</Table.Cell>
                <Table.Cell size="2">開始日時</Table.Cell>
                <Table.Cell size="2">終了日時</Table.Cell>
                <Table.Cell size="4.5">クーポン名</Table.Cell>
                <Table.Cell size="2.5">発行店舗</Table.Cell>
              </Table.Row>
            </Table.Header>
            <Table.Body>
              {coupons?.rows?.map((coupon) => (
                <CouponListRow data={coupon} key={coupon.id} />
              ))}
            </Table.Body>
            <Table.Footer>
              <Table.Row noBorder>
                <Table.Cell colSpan={6} align="center" styles={{ paddingTop: '16px' }}>
                  <Pager pagination={pagination} onChangePage={onChangePage} />
                </Table.Cell>
              </Table.Row>
            </Table.Footer>
          </Table>
        </>
      )}
    </div>
  );
};

export default CouponListTable;
